import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Model from '@tripian/model';
import { api } from '@tripian/core';
import { saveError } from '../redux/action/user';

const usePoiCategory = () => {
  const [loadingPoiCategories, setLoadingPoiCategories] = useState<boolean>(true);
  const [poiCategories, setPoiCategories] = useState<Model.PoiCategory[]>([]);

  const dispatch = useDispatch();

  useEffect(() => {
    api
      .poiCategories()
      .then((pCategories: Model.PoiCategory[]) => {
        setPoiCategories(pCategories);
      })

      .catch((poiCategoriesError) => {
        dispatch(saveError('poiCategories', 'Fetch Poi categories', poiCategoriesError));
        throw poiCategoriesError;
      })
      .finally(() => {
        setLoadingPoiCategories(false);
      });
  }, [dispatch]);

  return { poiCategories, loadingPoiCategories };
};

export default usePoiCategory;
